import React from 'react';
import MenuCliente from '../Components/MenuCliente/menucliente';
import './renovacao.css';

function Renovacao(){
    return <div>      
      <MenuCliente />      
    </div>;
  }

export default Renovacao;